import { getTracerModules } from '@apptracer/sdk/lite';

import { packageName } from '../../../config';
import { storageManager } from '../storageManager';

/** Получение wuuid из хранилища */
export const getWidgetUuidQuery = () => {
  const tracerError = getTracerModules(packageName).error;

  try {
    return storageManager?.getItem('wuuid') || null;
  } catch (_) {
    tracerError?.error('Ошибка получения UUID виджета из хранилища');
    return null;
  }
};
